import { ApolloClient, gql } from '@apollo/client/core';
import * as Organization from './Organization';
import { Query } from '../../../generated/api.graphql';
import { ACCOUNT_AGNOSTIC } from '../../accountContext';

/**
 * What is left of the AppSchema account surface.
 *
 * The superadmin account administration — the paged account list, the single account read, fee
 * structures, save and delete — moved to the internal (VP staff) schema per ADR-009; it lives at
 * `src/api/Internal/Account/Api.ts` now. `organizations` stays here: it is a tenant-facing read
 * that the account switcher uses, not a staff-only one.
 */

export const ORGANIZATIONS_QUERY = gql`
  query Organizations {
    organizations {
      id
      name
      default
    }
  }
`;

export const fetchOrganizations = async (
  client: ApolloClient<Query>,
): Promise<Organization.Organization[]> => {
  // Account-agnostic: this is how the app finds out which accounts there are. Scoping the
  // question to an account would be circular, and it is what the switcher asks before one is
  // chosen.
  const { data } = await client.query({ query: ORGANIZATIONS_QUERY, fetchPolicy: 'network-only', context: ACCOUNT_AGNOSTIC });

  return (data.organizations ?? []).map(Organization.fromGql);
};
